import React, { useMemo } from 'react';
import { bool, node, string, array } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Container } from '@fiverr-private/layout_components';
import { useGigPageContext } from '@fiverr-private/gig_page_context';
import { reportContactSellerClick } from '../../../utils/contactSeller';
import ContactTrigger from '../../shared/ContactTrigger';
import { GradientBorderButton } from '../../shared/GradientBorderButton/GradientBorderButton';
import {contactSellerTabButtonStyle} from "../ContactSellerOptions/ContactButtonStyles/TabContent";
import { isInLynxesCtaReworkTest } from '../../../utils/experiments/isInLynxesCtaRework';

const ContactSellerBtn = ({
    asContactSellerOption,
    mixpanelSourceComponent,
    bqSourceName,
    triggerId,
    triggerCopy,
    triggerPlacement,
    children,
    packageList,
}) => {
    const { biEvents, floatingChatData } = useGigPageContext();

    const onClick = () =>
        reportContactSellerClick({
            biEvents,
            mixpanelSourceComponent,
            bqSourceName,
            metricKey: 'contact_seller.click',
        });

    const contactSellerButtonPropsTest = useMemo(() => ({
        backgroundColor: 'black',
        color: 'white',
        marginBottom: '4',
        paddingX: { default: '6', sm: '0' },
    }), []);

    const isInLynxesCtaReworkExperiment = isInLynxesCtaReworkTest(packageList || []);

    return (
        <Container
            {...(isInLynxesCtaReworkExperiment
                ? { textAlign: "center", marginX: { default: "6", sm: "0" } }
                : {})}
        >
            <ContactTrigger
                className={classNames({ [contactSellerTabButtonStyle]: !isInLynxesCtaReworkExperiment })}
                source="contact-btn"
                onClick={onClick}
                bqSourceName={bqSourceName}
                triggerId={triggerId}
                triggerCopy={triggerCopy}
                triggerPlacement={triggerPlacement}
            >
                {(triggerProps) =>
                    asContactSellerOption ? (
                        <Container {...triggerProps}>{children}</Container>
                    ) : (
                        <GradientBorderButton {...triggerProps} variant="outline" fullWidth withBorder={floatingChatData?.isEligible}
                        withAdditionalMargin={!isInLynxesCtaReworkExperiment}
                        {...isInLynxesCtaReworkExperiment ? contactSellerButtonPropsTest : {}}
                        >
                            {children}
                        </GradientBorderButton>
                    )
                }
            </ContactTrigger>
        </Container>
    );
};

ContactSellerBtn.propTypes = {
    asContactSellerOption: bool,
    mixpanelSourceComponent: string,
    bqSourceName: string,
    children: node,
    triggerId: string,
    triggerCopy: string,
    triggerPlacement: string,
    packageList: array,
};

const mapStateToProps = (state) => ({
    packageList: state.packages?.packageList || [],
});

export default connect(mapStateToProps)(ContactSellerBtn);